// extracted by mini-css-extract-plugin
module.exports = {"min":"SliderIndicatorsContainer_min__1lrwu","max":"SliderIndicatorsContainer_max__elZAZ"};